/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { ReplaceEncountersImagesBody, ReplaceImageErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const replaceEncountersImages = (
  encounterId: number,
  imageId: number,
  replaceEncountersImagesBody: ReplaceEncountersImagesBody,
) => {
  const formData = new FormData();
  formData.append(`file`, replaceEncountersImagesBody.file);
  if (replaceEncountersImagesBody.bodyLocation !== undefined) {
    formData.append(`bodyLocation`, replaceEncountersImagesBody.bodyLocation);
  }
  if (replaceEncountersImagesBody.description !== undefined) {
    formData.append(`description`, replaceEncountersImagesBody.description);
  }

  return api<void>({
    url: `/api/encounters/${encounterId}/images/${imageId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getReplaceEncountersImagesMutationOptions = <
  TError = ReplaceImageErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceEncountersImages>>,
    TError,
    { encounterId: number; imageId: number; data: ReplaceEncountersImagesBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceEncountersImages>>,
  TError,
  { encounterId: number; imageId: number; data: ReplaceEncountersImagesBody },
  TContext
> => {
  const mutationKey = ['replaceEncountersImages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceEncountersImages>>,
    { encounterId: number; imageId: number; data: ReplaceEncountersImagesBody }
  > = (props) => {
    const { encounterId, imageId, data } = props ?? {};

    return replaceEncountersImages(encounterId, imageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceEncountersImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceEncountersImages>>
>;
export type ReplaceEncountersImagesMutationBody = ReplaceEncountersImagesBody;
export type ReplaceEncountersImagesMutationError = ReplaceImageErrorResponse;

export const useReplaceEncountersImages = <TError = ReplaceImageErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof replaceEncountersImages>>,
      TError,
      { encounterId: number; imageId: number; data: ReplaceEncountersImagesBody },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof replaceEncountersImages>>,
  TError,
  { encounterId: number; imageId: number; data: ReplaceEncountersImagesBody },
  TContext
> => {
  const mutationOptions = getReplaceEncountersImagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
